import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccommodationClientById } from '@/renderer/services/accommodationService';

/**
 * Full client/guest profile (identity + accommodation fields), read directly
 * from Supabase — not the PowerSync local cache, since accommodation-only
 * columns (country_id, date_of_birth, id_type, id_number,
 * accommodation_notes) aren't part of the synced `clients` schema.
 */
export function useAccommodationClient(clientId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.clientDetails(clientId),
    queryFn: () => fetchAccommodationClientById(clientId as string),
    enabled: Boolean(clientId),
  });
}
